var promoBanner = new Swiper('.promo-slide', {
    slidesPerView: 1, 
    centeredSlides: false, 
    spaceBetween:10,
    breakpoints: { 

      769: {

      },
      1024: {


      },
      1400: {
       spaceBetween:20,

      },
    }
});
